module.exports = __webpack_public_path__ + "img/filter-list.61029c65.svg";